import { useMemo } from 'react';
import withScrolling from 'react-dnd-scrolling';

const useVirtualListHelper = (listComponent) => {
    const ScrollingVirtualList = useMemo(() => withScrolling(listComponent), [listComponent]);
    return {
        ScrollingVirtualList,
    };
};

export { useVirtualListHelper };
//# sourceMappingURL=useVirtualListHelper.js.map
